import { CookieAttributes } from "js-cookie";

const tokenExpiresTimeSeconds = process.env.ACCESS_TOKEN_EXPIRE_TIME_SECONDS || 1800; // 30 minutes
const refreshTokenExpiresTimeSeconds = process.env.REFRESH_TOKEN_EXPIRE_TIME_SECONDS || 604800; // 7 days

const cookieOptions: CookieAttributes = { secure: true, sameSite: "strict" };

export const getAuthCookieName = (name: string) =>
	`kldx_${process.env.APP_ENV === "production" ? name : `${name}_${process.env.APP_ENV}`}`;

const tokenCookieOptions = (date = new Date()) => {
	return {
		...cookieOptions,
		expires: new Date(date.getTime() + (tokenExpiresTimeSeconds as number) * 1000),
	};
};

const refreshTokenCookieOptions = (date = new Date()) => {
	return {
		...cookieOptions,
		expires: new Date(date.getTime() + (refreshTokenExpiresTimeSeconds as number) * 1000),
	};
};

export { tokenCookieOptions, refreshTokenCookieOptions };

export default cookieOptions;
